export default `<div class="styles__CategoryList">
<div class="column">
   <div class="group">
      <span>
         <h2 class="title">Shop by Activity</h2>
      </span>
      <ul>
        <li>
            <a href="/view/outerwear/" title="Men's Outerwear">
            <div class="item">
                <div class="item-label">Outerwear</div>
             </div>
          </a>
        </li>
      </ul>
   </div>
</div>
</div>`